import { Component } from 'opus-angular-seed-core';

@Component({
    template: `
    <div class="heading01 type01">
        <h1>{{ 'tasklist.Tasklists' | translate }}</h1>
        <ul class="actions01">
            <li>
                <a class="btn add" ui-sref="authorized.user.tasklist.add()">{{ 'tasklist.Assign tasklist' | translate }}</a>
            </li>
            <li>
                <a class="btn ico-filter" ng-click="vm.showFilter=!vm.showFilter">{{ 'tasklist.Filter tasklists' | translate }}</a>
            </li>
            <li>
                <a ng-click="vm.exportCsv()" class="btn ico-download">{{ 'reports.Export as csv' | translate }}</a>
            </li>
        </ul>
    </div>
    <user-tasklist-list-filter list="vm.list" filter="vm.filter" show-filter="vm.showFilter"></user-tasklist-list-filter>
    <list-factory-empty list="vm.list" show-add-message="true"></list-factory-empty>
    <div class="well" ng-if="!vm.list.loading && vm.list.items.length">
        <table class="data01" datatable dt-options="vm.DATATABLES">
            <thead>
            <tr>
                <th>{{ 'tasklist.Employee' | translate }}</th>
                <th>{{ 'tasklist.Tasklist template' | translate }}</th>
                <th>{{ 'tasklist.Next deadline' | translate }}</th>
                <th>{{ 'tasklist.Next task' | translate }}</th>
                <th>{{ 'tasklist.Status' | translate }}</th>
                <th class="actions">&nbsp;</th>
            </tr>
            </thead>
            <tbody>
            <tr ng-repeat="item in vm.list.items" ng-class="{ status01: item.nextDeadline && vm.MomentService.isPassedDate(item.nextDeadline)}">
                <td>{{ item.user.displayName }}</td>
                <td>{{ item.tasklistTemplate.name }}</td>
                <td ng-class="{ red: item.nextDeadline && vm.MomentService.isPassedDate(item.nextDeadline)}"
                >{{ vm.MomentService.formatDate(item.nextDeadline) }}</td>
                <td><span ng-if="item.nextTask">{{ item.nextTask.name }}</span></td>
                <td>{{ vm.TASKLIST_STATUS_ENUM.LABELS[item.status] }}</td>
                <td class="actions">
                    <a class="btn edit" ui-sref="authorized.user.tasklist.edit({ id: item.id })">{{ 'tasklist.Edit' | translate }}</a>
                    <a class="btn ico-check" ng-click="vm.tasklistModal(item.id)">{{ 'tasklist.Mark tasks complete' | translate }}</a>
                </td>
            </tr>
            </tbody>
        </table>
        <pagination list="vm.list"></pagination>
    </div>
    `
})
export default class {
    constructor ($translate, lodash, DATATABLES, ListFactory, MomentService, ModalService, TasklistResource, TASKLIST_STATUS_ENUM,
        AuthResource, ReportService, TokenService, $window) {
        this.lodash = lodash;
        this.$translate = $translate;
        this.DATATABLES = DATATABLES;
        this.ListFactory = ListFactory;
        this.MomentService = MomentService;
        this.ModalService = ModalService;
        this.TasklistResource = TasklistResource;
        this.TASKLIST_STATUS_ENUM = TASKLIST_STATUS_ENUM;
        this.AuthResource = AuthResource;
        this.ReportService = ReportService;
        this.TokenService = TokenService;
        this.$window = $window;
    }

    $onInit () {
        this.filter = { expand: 'user,tasklistTemplate,nextTask,tasklistTask.completor' };
        this.list = this.ListFactory.createWithPagination(
            this.TasklistResource.query.bind(this.TasklistResource)
        );
    }

    exportCsv () {
        this.AuthResource
            .requestTacToken().$promise
            .then(({ token }) => {
                const qs = this.ReportService.buildQueryString(this.filter);
                const lang = this.TokenService.getActiveLanguage(true);
                const url = `${SEED_CORE.ENV.API_URL}tasklist/tasklist/tasklist-export?tacToken=${token}&${qs}&_lang=${lang}`;
                this.$window.open(url);
            });
    }

    tasklistModal (id) {
        this.ModalService
            .open({
                template: `
                    <modals-user-tasklist-mark-complete
                        uib-modal-instance="vm.$uibModalInstance"
                        tasklist="vm.tasklist"
                    />
                `,
                resolve: {
                    tasklist (TasklistResource) {
                        return TasklistResource.get({ id, expand: 'tasklistTasks.file,tasklistTemplate,user,nextTask,tasklistTasks.completor' }).$promise;
                    }
                },
                controller ($uibModalInstance, tasklist) {
                    this.$uibModalInstance = $uibModalInstance;
                    this.tasklist = tasklist;
                },
                size: 'medium'
            })
            .then(() => this.list.fetch())
        ;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/user/tasklist/list/index.js